export default __webpack_public_path__ + "static/media/fi_all_ages.667c4cd8.png";